import Actions from "../../redux/actions/index";
import { store, persistor } from "../../redux/store";
import { END_POINTS } from "./EndPoints";
import { doAgentPost, doAdminPost } from "./index";
import { stopSocketConnect } from "../../socket";
import RoutePath from "../routes/RoutePath";

const clearClientSession = async () => {
  try {
    stopSocketConnect();
  } catch (e) {
    /* ignore */
  }
  store.dispatch(Actions.logoutAction());
  try {
    await persistor.purge();
  } catch (e) {
    /* ignore */
  }
  localStorage.clear();
};

/**
 * Full logout for agent / nurse (roleId 3) sessions.
 */
export const logoutAgentSession = async (history) => {
  try {
    await doAgentPost(END_POINTS.LOGOUT_API, {});
  } catch (e) {
    /* ignore — still clear local session */
  }
  await clearClientSession();
  if (history && history.push) {
    history.push(RoutePath.LOGIN_SCREEN_PATH);
  } else {
    window.location.href = RoutePath.LOGIN_SCREEN_PATH;
  }
};

/**
 * Full logout for admin / vendor / agent header sessions.
 * @param {'admin'|'vendor'|'agent'|string} roleRoute
 */
export const logoutPortalSession = async (roleRoute, history) => {
  try {
    if (roleRoute === "admin") {
      await doAdminPost(END_POINTS.LOGOUT_API, {}, true);
    } else if (roleRoute === "vendor") {
      await doAdminPost(END_POINTS.LOGOUT_API, {}, false);
    } else {
      await doAgentPost(END_POINTS.LOGOUT_API, {});
    }
  } catch (e) {
    /* ignore — still clear local session */
  }

  await clearClientSession();

  let path = RoutePath.LOGIN_SCREEN_PATH;
  if (roleRoute === "admin") path = RoutePath.ADMIN_LOGIN_SCREEN_PATH;
  if (roleRoute === "vendor") path = RoutePath.VENDOR_LOGIN_SCREEN_PATH;

  if (history && history.push) {
    history.push(path);
  } else {
    window.location.href = path;
  }
};
